import ModalProperties from "../interfaces/ModalProperties";

export enum ModalActionTypes {
    ShowModal = 'SHOW_MODAL',
    HideModal = 'HIDE_MODAL',
}

export interface ModalAction {
    type: ModalActionTypes;
    payload?: ModalProperties;
}

export function showModal(payload: ModalProperties): ModalAction {
    return {
        type: ModalActionTypes.ShowModal,
        payload,
    };
}

export function hideModal(): ModalAction {
    return {
        type: ModalActionTypes.HideModal,
    };
}
